import Variable from "../../Helpers/Variable";
import SortableSchedules from "../Helpers/SortableSchedules";

export default class ScheduleLocalFilter {
    constructor(schedules, filterDTO, stages) {
        if (!(schedules instanceof SortableSchedules)) {
            throw new DOMException('Expected SortableSchedules instance');
        }

        this.stages = stages;
        this.filterDTO = filterDTO;
        this.originalSchedules = schedules.getOriginalSchedules();
        this.filteredSchedules = schedules.getOriginalSchedules();
        this.pipeline();
    }

    pipeline() {
        this.filterByDay()
            .filterByTag()
            .filterByStage();
    }

    filterByDay() {
        if (Variable.empty(this.filteredSchedules) || Variable.empty(this.filterDTO.getDay())) {
            return this;
        }

        let schedules = [];
        const filterDate = new Date(`${this.filterDTO.getDay()} 00:00:00`);
        filterDate.setHours(0, 0, 0, 0);

        this.filteredSchedules.forEach((schedule) => {
            const scheduleDate = new Date(schedule['start']);
            scheduleDate.setHours(0, 0, 0, 0);

            if (scheduleDate.getTime() === filterDate.getTime()) {
                schedules.push(schedule);
            }
        });

        this.filteredSchedules = schedules;

        return this;
    }

    filterByTag() {
        if (Variable.empty(this.filteredSchedules) || Variable.empty(this.filterDTO.getTag())) {
            return this;
        }

        let schedules = [];

        this.filteredSchedules.forEach((schedule) => {
            if (schedules.tags.includes(this.filterDTO.getTag())) {
                schedules.push(schedule);
            }
        });

        this.filteredSchedules = schedules;

        return this;
    }

    filterByStage() {
        if (Variable.empty(this.filteredSchedules) || Variable.empty(this.filterDTO.getStage())) {
            return this;
        }

        const stage = this.getStageById(this.filterDTO.getStage());

        if (stage === null) {
            return this;
        }

        let schedules = [];

        this.filteredSchedules.forEach((schedule) => {
            if (stage['name'] === schedule['stage']) {
                schedules.push(schedule);
            }
        });

        this.filteredSchedules = schedules;

        return this;
    }

    getStageById(stage_id) {
        let stage = null;

        this.stages.forEach((loopStage) => {
            if (loopStage['id'] === stage_id) {
                stage = loopStage;
            }
        });

        return stage;
    }

    getFilteredSchedules() {
        return this.filteredSchedules ?? [];
    }

    getOriginalSchedules() {
        return this.originalSchedules;
    }
}
